<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="terms">
      <div class="main-content">
        <div class="page-width pre-formatted">
          <div class="section-header text-center">
            <h1>{{ $t('termsTitle') }}</h1>
          </div>
          <!-- <p>{{ companyTerms }}</p> -->
          <div class="terms-list">
            <p v-html="$t('termsBody1')"></p>
          </div>
          <div class="terms-list">
            <p v-html="$t('termsBody2')"></p>
          </div>
          <div class="terms-list">
            <p v-html="$t('termsBody3')"></p>
          </div>
          <div class="terms-list">
            <p v-html="$t('termsBody4')"></p>
          </div>
          <div class="terms-list">
            <p v-html="$t('termsBody5')"></p>
          </div>
          <div class="terms-list">
            <p v-html="$t('termsBody6')"></p>
          </div>
          <div class="terms-list">
            <p v-html="$t('termsBody7')"></p>
          </div>
          <div class="terms-list">
            <p v-html="$t('termsBody8')"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb'
import { Config } from '../../../config/default';
export default {
  name: "terms",
  components: {
    breadcrumb,
  },
  data() {
    return {
      companyTerms: Config.COMPANY_TERMS,
      path2: this.$t('terms'),
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/terms.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/terms.vue